import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../../../constants/common'
import { parseServerValidation } from '../../../../utils/validation'
import { getIsLimitReached } from '../ProfileContactsWidget.utils'

export function useProfileContactsWidgetLoader({
  api,
  canEdit,
  onHideWidget,
  onLoaded,
}) {
  const [addTypes, setAddTypes] = useState(EMPTY_LIST)
  const [contacts, setContacts] = useState(EMPTY_LIST)
  const [limit, setLimit] = useState(null)

  const [canCreate, setCanCreate] = useState(false)

  const [isLoaded, setIsLoaded] = useState(false)

  const isLimitReached = getIsLimitReached({ contacts, limit })

  function fetchContacts() {
    api
      .load()
      .then(
        ({
          addTypes: loadedAddTypes,
          canCreate: loadedCanCreate,
          contacts: loadedContacts,
          limit: loadedLimit,
        }) => {
          setAddTypes(loadedAddTypes)

          setCanCreate(loadedCanCreate)

          setContacts(loadedContacts)

          setLimit(loadedLimit)
        }
      )
      .catch(parseServerValidation)
      .finally(() => {
        setIsLoaded(true)
        onLoaded?.()
      })
  }

  useEffect(() => {
    fetchContacts()
  }, [])

  useEffect(() => {
    if (isLoaded && !canEdit && contacts.length === 0) {
      onHideWidget()
    }
  }, [canEdit, contacts.length, isLoaded, onHideWidget])

  function updateContactValue(id, value) {
    setContacts(prev =>
      prev.map(contact => (contact.id === id ? { ...contact, value } : contact))
    )
  }

  return {
    addTypes,
    canCreate,
    contacts,
    fetchContacts,
    isLimitReached,
    isLoaded,
    updateContactValue,
  }
}
